export default __webpack_public_path__ + "static/media/bid.bc082f9a.png";